/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CarQuickEstimatesForm_viewer = {
    readonly currentUser: {
        readonly fullName: string;
    } | null;
    readonly " $refType": "CarQuickEstimatesForm_viewer";
};
export type CarQuickEstimatesForm_viewer$data = CarQuickEstimatesForm_viewer;
export type CarQuickEstimatesForm_viewer$key = {
    readonly " $data"?: CarQuickEstimatesForm_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CarQuickEstimatesForm_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "CarQuickEstimatesForm_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentUser",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "fullName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '959fa7602b0f04e3ea6ac201533e5003';
export default node;
